import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import { getClassName } from "./functions";
import AppContext from "../../context/AppContext";

class Tryb extends PureComponent<any> {
  static contextType = AppContext;

  handleClick = () => {
    const { changeMode } = this.context;
    const { mode } = this.props;
    changeMode(mode.id);
  };

  render() {
    const { mode } = this.props;
    return (
      <button
        className={getClassName(mode.isSelected)}
        onClick={this.handleClick}
        title={mode.title}
      >
        {mode.name}
      </button>
    );
  }
}

export default Tryb;
